import { lifestyleEntries } from "@/mocks/gallery";
import Reveal from "@/pages/home/components/Reveal";

export default function LifestyleList() {
  return (
    <section id="lifestyle" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8">
        <Reveal>
          <div className="max-w-3xl mb-10">
            <span className="text-xs font-label tracking-widest text-primary-600 uppercase">Lifestyle Log</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-semibold text-foreground-950">生活记录</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-700">
              按月份整理的日常拍摄记录，越靠前的条目越新。与主题分类不同，这里更强调拍摄当时的场景与状态，方便按时间顺序回看。
            </p>
          </div>
        </Reveal>

        <div className="flex flex-col gap-6 md:gap-8">
          {lifestyleEntries.map((entry, index) => (
            <Reveal key={entry.id} delay={index * 60}>
              <article className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-8 items-center rounded-lg bg-background-50 border border-background-200/80 p-4 md:p-6">
                <div className={`w-full h-56 md:h-72 rounded-lg overflow-hidden ${index % 2 === 1 ? "lg:order-2" : ""}`}>
                  <img
                    src={entry.image}
                    alt={`${entry.title}生活记录配图`}
                    title={`${entry.title} · 年轻的岳母日常记录`}
                    className="w-full h-full object-top"
                  />
                </div>
                <div className={index % 2 === 1 ? "lg:order-1" : ""}>
                  <div className="flex items-center gap-3">
                    <span className="px-3 py-1 rounded-full bg-primary-100 text-xs font-medium text-primary-700">
                      {entry.month}
                    </span>
                    <span className="text-xs text-foreground-500">{entry.meta}</span>
                  </div>
                  <h3 className="mt-4 font-heading text-lg md:text-2xl font-semibold text-foreground-950">{entry.title}</h3>
                  <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">{entry.desc}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}